var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconConsole(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2067 6.33331H7.79337C6.6387 6.33358 5.52513 6.76192 4.66791 7.53552C3.8107 8.30912 3.27073 9.37305 3.15237 10.5216C3.14537 10.5823 3.14071 10.6395 3.13254 10.699C3.03804 11.4853 2.33337 17.3653 2.33337 19.1666C2.33337 20.0949 2.70212 20.9851 3.3585 21.6415C4.01488 22.2979 4.90512 22.6666 5.83337 22.6666C7.00004 22.6666 7.58337 22.0833 8.16671 21.5L9.81637 19.8503C10.2539 19.4127 10.8473 19.1668 11.466 19.1666H16.534C17.1528 19.1668 17.7462 19.4127 18.1837 19.8503L19.8334 21.5C20.4167 22.0833 21 22.6666 22.1667 22.6666C23.095 22.6666 23.9852 22.2979 24.6416 21.6415C25.298 20.9851 25.6667 20.0949 25.6667 19.1666C25.6667 17.3641 24.962 11.4853 24.8675 10.699C24.8594 10.6406 24.8547 10.5823 24.8477 10.5228C24.7296 9.37401 24.1898 8.3098 23.3325 7.53595C22.4753 6.76211 21.3616 6.33361 20.2067 6.33331Z",
    stroke: "#222222",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 13.3333H11.6667",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33337 11V15.6667",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 14.5H17.5117",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21 12.1667H21.0117",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconConsole);
export default __webpack_public_path__ + "static/media/Icon-Console.985b69adfcecb6d9b9dec54ef3024272.svg";
export { ForwardRef as ReactComponent };